import React, { memo } from 'react';
import { SubsidiaryHeader } from '../../../components/shared/SubsidiaryHeader';
import { SubsidiaryFooter } from '../../../components/shared/SubsidiaryFooter';
const navigation = [{
  name: 'Home',
  href: '/palace-hotel'
}, {
  name: 'Rooms & Suites',
  href: '/palace-hotel/rooms'
}, {
  name: 'Dining',
  href: '/palace-hotel/dining'
}, {
  name: 'Spa & Wellness',
  href: '#'
}, {
  name: 'Meetings & Events',
  href: '#'
}, {
  name: 'Contact',
  href: '/palace-hotel#contact'
}];
const footerLinks = [{
  title: 'Accommodations',
  items: [{
    name: 'Deluxe Rooms',
    href: '#'
  }, {
    name: 'Executive Suites',
    href: '#'
  }, {
    name: 'Presidential Suite',
    href: '#'
  }, {
    name: 'Special Offers',
    href: '#'
  }]
}, {
  title: 'Experiences',
  items: [{
    name: 'Fine Dining',
    href: '#'
  }, {
    name: 'Spa Treatments',
    href: '#'
  }, {
    name: 'Fitness Center',
    href: '#'
  }, {
    name: 'Events & Weddings',
    href: '#'
  }]
}];
const restaurants = [{
  id: 'azure',
  name: 'Azure',
  description: 'Fine dining restaurant offering contemporary international cuisine with African influences.',
  image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  hours: 'Breakfast: 6:30 AM - 10:30 AM<br>Dinner: 6:00 PM - 10:30 PM',
  cuisine: 'International, African Fusion'
}, {
  id: 'lotus',
  name: 'Lotus Garden',
  description: 'Elegant Asian restaurant featuring authentic dishes from China, Japan, and Thailand.',
  image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  hours: 'Lunch: 12:00 PM - 3:00 PM<br>Dinner: 6:00 PM - 11:00 PM',
  cuisine: 'Pan-Asian'
}, {
  id: 'terrace',
  name: 'The Terrace',
  description: 'Casual all-day dining venue with panoramic views, serving international favorites.',
  image: 'https://images.unsplash.com/photo-1537639622086-67481a19bf62?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  hours: 'Open daily: 11:00 AM - 11:00 PM',
  cuisine: 'International, Mediterranean'
}];
const bars = [{
  id: 'skylounge',
  name: 'Sky Lounge',
  description: 'Rooftop bar offering craft cocktails, premium spirits, and breathtaking city views.',
  image: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80',
  hours: 'Open daily: 4:00 PM - 1:00 AM'
}, {
  id: 'lobby',
  name: 'Lobby Bar',
  description: 'Sophisticated bar in the heart of the hotel, perfect for meetings or relaxation.',
  image: 'https://images.unsplash.com/photo-1560840881-4bbcd415a9ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  hours: 'Open daily: 10:00 AM - 12:00 AM'
}];
export function PalaceHotelDining() {
  return <div className="flex flex-col min-h-screen" data-id="element-593">
      <SubsidiaryHeader name="Solochus Palace Hotel" color="bg-amber-50 text-amber-900" navigation={navigation} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/iUXecTUoL9PBBs7nqvYwnz/SOLO_hotel.png" data-id="element-594" />
      <main className="flex-grow" data-id="element-595">
        {/* Hero Section */}
        <section className="bg-amber-100 py-16" data-id="element-596">
          <div className="container mx-auto px-4" data-id="element-597">
            <h1 className="text-4xl font-bold text-amber-900 text-center mb-6" data-id="element-598">
              Dining Experiences
            </h1>
            <p className="text-xl text-amber-800 text-center max-w-2xl mx-auto" data-id="element-599">
              Embark on a culinary journey with our exceptional restaurants and
              bars, each offering a unique dining experience.
            </p>
          </div>
        </section>
        {/* Restaurants Section */}
        <section className="py-16" data-id="element-600">
          <div className="container mx-auto px-4" data-id="element-601">
            <h2 className="text-3xl font-bold text-amber-900 text-center mb-12" data-id="element-602">
              Our Restaurants
            </h2>
            <div className="space-y-16" data-id="element-603">
              {restaurants.map((restaurant, index) => <div key={restaurant.id} className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 items-center`} data-id="element-604">
                  <div className="lg:w-1/2" data-id="element-605">
                    <img src={restaurant.image} alt={restaurant.name} className="w-full h-80 object-cover rounded-lg shadow-md" data-id="element-606" />
                  </div>
                  <div className="lg:w-1/2" data-id="element-607">
                    <h3 className="text-2xl font-bold text-amber-900 mb-3" data-id="element-608">
                      {restaurant.name}
                    </h3>
                    <p className="text-gray-700 mb-4" data-id="element-609">
                      {restaurant.description}
                    </p>
                    <div className="bg-amber-50 p-4 rounded-md mb-6" data-id="element-610">
                      <div className="mb-2" data-id="element-611">
                        <span className="font-semibold text-amber-800" data-id="element-612">
                          Hours:{' '}
                        </span>
                        <span dangerouslySetInnerHTML={{
                      __html: restaurant.hours
                    }} data-id="element-613" />
                      </div>
                      <div data-id="element-614">
                        <span className="font-semibold text-amber-800" data-id="element-615">
                          Cuisine:{' '}
                        </span>
                        <span data-id="element-616">{restaurant.cuisine}</span>
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-3" data-id="element-617">
                      <a href="#" className="px-4 py-2 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors" data-id="element-618">
                        View Menu
                      </a>
                      <a href="#" className="px-4 py-2 border border-amber-600 text-amber-600 font-medium rounded-md hover:bg-amber-50 transition-colors" data-id="element-619">
                        Reserve a Table
                      </a>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Bars Section */}
        <section className="py-16 bg-amber-50" data-id="element-620">
          <div className="container mx-auto px-4" data-id="element-621">
            <h2 className="text-3xl font-bold text-amber-900 text-center mb-12" data-id="element-622">
              Bars & Lounges
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-623">
              {bars.map(bar => <div key={bar.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-624">
                  <img src={bar.image} alt={bar.name} className="w-full h-60 object-cover" data-id="element-625" />
                  <div className="p-6" data-id="element-626">
                    <h3 className="text-xl font-bold text-amber-900 mb-2" data-id="element-627">
                      {bar.name}
                    </h3>
                    <p className="text-gray-700 mb-4" data-id="element-628">{bar.description}</p>
                    <div className="mb-4" data-id="element-629">
                      <span className="font-semibold text-amber-800" data-id="element-630">
                        Hours:{' '}
                      </span>
                      <span data-id="element-631">{bar.hours}</span>
                    </div>
                    <a href="#" className="inline-block px-4 py-2 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors" data-id="element-632">
                      View Menu
                    </a>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Private Dining Section */}
        <section className="py-16" data-id="element-633">
          <div className="container mx-auto px-4" data-id="element-634">
            <div className="max-w-3xl mx-auto text-center" data-id="element-635">
              <h2 className="text-3xl font-bold text-amber-900 mb-6" data-id="element-636">
                Private Dining
              </h2>
              <p className="text-gray-700 mb-8" data-id="element-637">
                Create memorable dining experiences with our private dining
                options. Perfect for intimate celebrations, business dinners, or
                special occasions.
              </p>
              <div className="bg-amber-50 p-6 rounded-lg" data-id="element-638">
                <h3 className="text-xl font-bold text-amber-800 mb-3" data-id="element-639">
                  Private Dining Features
                </h3>
                <ul className="text-left space-y-2 max-w-md mx-auto mb-6" data-id="element-640">
                  <li className="flex items-center" data-id="element-641">
                    <span className="text-amber-600 mr-2" data-id="element-642">✓</span>
                    <span data-id="element-643">Customized menus from our master chefs</span>
                  </li>
                  <li className="flex items-center" data-id="element-644">
                    <span className="text-amber-600 mr-2" data-id="element-645">✓</span>
                    <span data-id="element-646">Elegant private rooms for 8-20 guests</span>
                  </li>
                  <li className="flex items-center" data-id="element-647">
                    <span className="text-amber-600 mr-2" data-id="element-648">✓</span>
                    <span data-id="element-649">Dedicated service staff</span>
                  </li>
                  <li className="flex items-center" data-id="element-650">
                    <span className="text-amber-600 mr-2" data-id="element-651">✓</span>
                    <span data-id="element-652">Wine pairing recommendations</span>
                  </li>
                  <li className="flex items-center" data-id="element-653">
                    <span className="text-amber-600 mr-2" data-id="element-654">✓</span>
                    <span data-id="element-655">Audiovisual equipment available</span>
                  </li>
                </ul>
                <a href="#" className="inline-block px-6 py-3 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors" data-id="element-656">
                  Inquire About Private Dining
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SubsidiaryFooter name="Solochus Palace Hotel" description="Experience luxury and exceptional service at Lagos' premier hotel destination." color="bg-amber-900" textColor="text-white" links={footerLinks} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/iUXecTUoL9PBBs7nqvYwnz/SOLO_hotel.png" data-id="element-657" />
    </div>;
}